import { Box, FormControl, styled } from '@mui/material';
import { Control, FormState, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextInput2 from './TextInput2';

const PREFIX = 'NameInput';

const classes = {
  name: `${PREFIX}-name`,
  first: `${PREFIX}-first`,
  middle: `${PREFIX}-middle`,
  last: `${PREFIX}-last`,
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.name}`]: {
    display: 'flex',
  },

  [`& .${classes.first}`]: {
    marginRight: theme.spacing(0.5),
    flexGrow: 1,
  },

  [`& .${classes.middle}`]: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    flexGrow: 1,
  },

  [`& .${classes.last}`]: {
    marginLeft: theme.spacing(0.5),
    flexGrow: 1,
  },
}));

interface NameProps {
  namePrefix?: string;
  className?: string;
  control: Control;
  formState: FormState<any>;
  required?: boolean;
  firstNameLabel?: string;
  lastNameLabel?: string;
  showMiddleName?: boolean;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
}

export default function Name({
  namePrefix = '',
  className,
  control,
  formState,
  required = true,
  firstNameLabel,
  lastNameLabel,
  showMiddleName = false,
  rules,
}: NameProps) {
  const { t } = useTranslation('common');

  const firstLabel: string = firstNameLabel || t('common.firstName');
  const lastLabel: string = lastNameLabel || t('common.lastName');
  const middleLabel = t('driver.middleName');

  return (
    <StyledFormControl className={className}>
      <Box component="div" className={classes.name}>
        <TextInput2
          label={firstLabel}
          name={namePrefix + 'FirstName'}
          className={classes.first}
          required={required}
          control={control}
          errors={formState.errors}
          rules={rules}
          inputProps={{ maxLength: 50 }}
        />
        {showMiddleName ? (
          <TextInput2
            label={middleLabel}
            name={namePrefix + 'MiddleName'}
            className={classes.middle}
            rules={rules}
            required={false}
            control={control}
            errors={formState.errors}
            inputProps={{ maxLength: 50 }}
          />
        ) : null}
        <TextInput2
          label={lastLabel}
          name={namePrefix + 'LastName'}
          className={classes.last}
          required={required}
          control={control}
          errors={formState.errors}
          rules={rules}
          inputProps={{ maxLength: 50 }}
        />
      </Box>
    </StyledFormControl>
  );
}
